/* eslint-disable @typescript-eslint/no-explicit-any */

import { MoreOutlined } from "@ant-design/icons";
import { Button, Card, Dropdown, Image, Input, InputNumber } from "antd";
import { useRef, useState } from "react";
import { DeleteIcon } from "../../../../../../atoms/CustomIcons";
import ConfirmDelete from "../../../../../../atoms/ConfirmDelete";
import { PopUp } from "../../../../../../atoms/PopUp";

export default function LineItems(props: any) {
  const { lineItemData, color, setGroupedData, serviceLineId } = props;
  const [confirmDelete, setConfirmDelete] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const deleteFunction = () => {
    setGroupedData((prevData: any) =>
      prevData.map((serviceLine: any) =>
        serviceLine.service_line_id === serviceLineId
          ? {
              ...serviceLine,
              line_items: serviceLine.line_items.filter(
                (item: any) => item.id !== lineItemData.id
              ),
            }
          : serviceLine
      )
    );
    if (dropdownRef.current) {
      dropdownRef.current.click();
    }
    setConfirmDelete(false);
  };

  const confirmDeleteService = {
    visibility: confirmDelete,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmDelete(false)}
        heading="Remove line item from estimate"
        paragraph={
          <>
            This line item will be removed from this estimate. <br />
            <br />
            Are you sure you want to remove it?
          </>
        }
        btnText="Remove line item"
        btnApi={deleteFunction}
        loading={false}
        isArchivePopup={true}
      />
    ),
    width: 480,
    onCancel: () => setConfirmDelete(false),
  };

  const serviceItems = [
    {
      key: "1",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/reset-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled={true}
        >
          Reset all service line numbers to default
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setConfirmDelete(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          Remove line item
        </Button>
      ),
    },
  ];
  return (
    <Card
      className={`${color} estimateServicesList`}
      style={{ cursor: "pointer" }}
    >
      <div className="top_wrap" style={{ margin: 0 }}>
        <div className="top_wrap_left">
          <h4>
            <Input
              type="text"
              onChange={(e) => {
                setGroupedData((prevData: any) => {
                  return prevData.map((serviceLine: any) => {
                    if (serviceLine.service_line_id === serviceLineId) {
                      return {
                        ...serviceLine,
                        line_items: serviceLine.line_items.map((item: any) =>
                          item.id === lineItemData.id
                            ? { ...item, name: e.target.value }
                            : item
                        ),
                      };
                    }
                    return serviceLine;
                  });
                });
              }}
              value={lineItemData?.name || ""}
              style={{
                background: lineItemData?.name ? "transparent" : "#FFF9D9",
              }}
              className="lineItemInput"
              placeholder="Enter line item"
            />
          </h4>
        </div>
        <Card className="innerCard">
          <div className="innerCardBox">
            <p>Total cost:</p>
            <h3>
              <InputNumber
                controls={false}
                className="serviceLineInput"
                addonBefore="$"
                placeholder="0"
                value={lineItemData?.total_cost || ""}
                style={{
                  background:
                    lineItemData?.total_cost > 0 ? "transparent" : "#FFF9D9",
                }}
                onChange={(e) => {
                  setGroupedData((prevData: any) => {
                    return prevData.map((serviceLine: any) => {
                      if (serviceLine.service_line_id === serviceLineId) {
                        return {
                          ...serviceLine,
                          line_items: serviceLine.line_items.map(
                            (item: any) => {
                              if (item.id === lineItemData.id) {
                                const totalPrice = item.total_cost
                                  ? (e * 100) /
                                    (100 - (item.gross_margin_perc || 0))
                                  : 0;
                                return {
                                  ...item,
                                  total_cost: e,
                                  total_price: totalPrice,
                                };
                              } else {
                                return item;
                              }
                            }
                          ),
                        };
                      }
                      return serviceLine;
                    });
                  });
                }}
              />
            </h3>
          </div>
          <div className="innerCardBox">
            <p>Total price:</p>
            <h3>
              ${Number(lineItemData?.total_price?.toFixed(2)).toLocaleString()}
            </h3>
          </div>
          <div className="innerCardBox">
            <p>GM:</p>
            <h3>
              <InputNumber
                className="serviceLineInput"
                addonAfter={<span>%</span>}
                placeholder="0"
                controls={false}
                max={99}
                min={0}
                value={lineItemData?.gross_margin_perc || ""}
                style={{
                  background:
                    lineItemData?.gross_margin_perc > 0
                      ? "transparent"
                      : "#FFF9D9",
                }}
                onChange={(e) => {
                  setGroupedData((prevData: any) => {
                    return prevData.map((serviceLine: any) => {
                      if (serviceLine.service_line_id === serviceLineId) {
                        return {
                          ...serviceLine,
                          line_items: serviceLine.line_items.map(
                            (item: any) => {
                              if (item.id === lineItemData.id) {
                                const totalPrice = item.total_cost
                                  ? (item?.total_cost * 100) / (100 - (e || 0))
                                  : 0;
                                return {
                                  ...item,
                                  gross_margin_perc: e,
                                  total_price: totalPrice,
                                };
                              } else {
                                return item;
                              }
                            }
                          ),
                        };
                      }
                      return serviceLine;
                    });
                  });
                }}
              />
            </h3>
          </div>
        </Card>

        <div className="estimateDropdown">
          <Dropdown
            menu={{ items: serviceItems }}
            trigger={["click"]}
            placement="bottomRight"
            className="actionButton"
          >
            <Button
              onClick={(x) => {
                x.stopPropagation();
                // setServiceLineIdRecord(groupData?.service_line_id);
              }}
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "0px",
                height: "36px",
                width: "36px",
                backgroundColor: "transparent",
                border: "1px solid #DEE5E6",
                borderRadius: "8px",
              }}
              className="only_icon"
              icon={<MoreOutlined />}
              ref={dropdownRef}
            />
          </Dropdown>
        </div>
      </div>
      <PopUp {...confirmDeleteService} />
    </Card>
  );
}
